import React, { Component, Fragment } from 'react'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { contentActions, imagesTimeActions } from '../../../actions'
import TextField from '@material-ui/core/TextField'
import SelectWrapped from '../../../components/SelectWrapped'
import { formatContentSelectValue, filterOptionsFunction } from '../../../utils'
import Typography from '@material-ui/core/Typography'
import * as API from '../../../api'
import { readOnly } from '../../../utils/permissions'
import Select from '@material-ui/core/Select'
import {
  IsbnField,
  CodigoTabelaField,
  EdicaoField,
  CopyrightField,
  CodigoCapituloField,
  DateField
} from '../../../components/Fields'
import MenuItem from '@material-ui/core/MenuItem'

const styles = theme => ({
  layout: {
    height: 'calc(100% - 64px)',
    position: 'relative'
  },
  contentForm: {
    background: '#fff',
    height: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing.unit * 3,
    overflow: 'auto'
  },
  formGroup: {
    padding: '12px 0'
  },
  formControl: {
    margin: '12px 0'
  }
})

class Aula extends Component {
  componentDidMount() {
    const { fetchImagesTimeAll } = this.props
    fetchImagesTimeAll()
  }

  render() {
    const {
      classes,
      content,
      handleChangeContent,
      handleChangeReference,
      contentFormErrors,
      imagesTime,
      formTouched,
      token
    } = this.props

    const isReadOnly = readOnly(content.tipo, token)

    if (!content.tipoOrigem) content.tipoOrigem = 'capitulo'

    switch (content.tipoOrigem) {
      case 'artigo':
        contentFormErrors.fields.tituloCapitulo = { valid: true }
        contentFormErrors.fields.codigoCapitulo = { valid: true }
        contentFormErrors.fields.tituloLivro = { valid: true }
        contentFormErrors.fields.isbn = { valid: true }
        contentFormErrors.fields.edicaoLivro = { valid: true }
        contentFormErrors.fields.autoresLivro = { valid: true }
        contentFormErrors.fields.especialidadesLivro = { valid: true }
        contentFormErrors.fields.copyrightLivro = { valid: true }
        contentFormErrors.fields.tituloDeT = { valid: true }
        contentFormErrors.fields.codigoDeT = { valid: true }
        contentFormErrors.fields.anoPublicacaoDeT = { valid: true }
        contentFormErrors.fields.autoresDeT = { valid: true }
        break
      case 'capitulo':
        contentFormErrors.fields.tituloArtigo = { valid: true }
        contentFormErrors.fields.codigoArtigo = { valid: true }
        contentFormErrors.fields.anoPublicacaoArtigo = { valid: true }
        contentFormErrors.fields.anoPublicacaoDeT = { valid: true }
        contentFormErrors.fields.tituloDeT = { valid: true }
        contentFormErrors.fields.codigoDeT = { valid: true }
        contentFormErrors.fields.dataAtualizacao = { valid: true }
        contentFormErrors.fields.autoresArtigo = { valid: true }
        contentFormErrors.fields.autoresDeT = { valid: true }
        break
      case 'diagnostico_e_tratamento':
        contentFormErrors.fields.tituloCapitulo = { valid: true }
        contentFormErrors.fields.codigoCapitulo = { valid: true }
        contentFormErrors.fields.tituloLivro = { valid: true }
        contentFormErrors.fields.isbn = { valid: true }
        contentFormErrors.fields.edicaoLivro = { valid: true }
        contentFormErrors.fields.autoresLivro = { valid: true }
        contentFormErrors.fields.especialidadesLivro = { valid: true }
        contentFormErrors.fields.copyrightLivro = { valid: true }
        contentFormErrors.fields.tituloArtigo = { valid: true }
        contentFormErrors.fields.codigoArtigo = { valid: true }
        contentFormErrors.fields.anoPublicacaoArtigo = { valid: true }
        contentFormErrors.fields.autoresArtigo = { valid: true }
        break
      default:
        break
    }

    const isValid = Object.keys(contentFormErrors.fields).map(function(key) {
      if (contentFormErrors.fields[key].valid === false) {
        return false
      } else {
        return true
      }
    })

    if (!isValid.includes(false)) {
      contentFormErrors.valid = true
    }

    return (
      <Fragment>
        <FormControl
          disabled={isReadOnly}
          error={!((contentFormErrors.fields || {})['titulo'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-titulo">Título</InputLabel>
          <Input
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, titulo: e.target.value })
            }}
            value={content.titulo}
            id="field-titulo"
          />
          {!((contentFormErrors.fields || {})['titulo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['titulo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangeContent({ ...content, autores: obj })
            }}
            error={!((contentFormErrors.fields || {})['autores'] || {}).valid && formTouched}
            value={formatContentSelectValue(content.autores || [])}
            placeholder="Selecione..."
            name="react-select-chip-label"
            label="Autores"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-label',
                loadOptions: API.authors.getSelectAuthors,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((contentFormErrors.fields || {})['autores'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['autores'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <FormControl
          error={!((contentFormErrors.fields || {})['codigo'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-codigo">Código</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            inputComponent={CodigoTabelaField}
            onChange={e => {
              handleChangeContent({ ...content, codigo: e.target.value })
            }}
            value={content.codigo || ''}
            id="field-codigo"
          />
          {!((contentFormErrors.fields || {})['codigo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['codigo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['url'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-url">Endereço da imagem (URL)</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, url: e.target.value })
            }}
            value={content.url}
            id="field-url"
          />
          {!((contentFormErrors.fields || {})['url'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['url'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['descricao'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-descricao">Resumo</InputLabel>
          <Input
            disabled={isReadOnly}
            multiline
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, descricao: e.target.value })
            }}
            value={content.descricao}
            id="field-descricao"
          />
          {!((contentFormErrors.fields || {})['descricao'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['descricao'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangeContent({ ...content, especialidades: obj })
            }}
            error={!((contentFormErrors.fields || {})['especialidades'] || {}).valid && formTouched}
            value={formatContentSelectValue(content.especialidades || [])}
            placeholder="Selecione..."
            name="react-select-chip-label"
            label="Especialidades"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-label',
                loadOptions: API.specialities.getSelectSpecialities,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((contentFormErrors.fields || {})['especialidades'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['especialidades'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangeContent({ ...content, palavrasChave: obj })
            }}
            error={!((contentFormErrors.fields || {})['palavrasChave'] || {}).valid && formTouched}
            value={formatContentSelectValue(content.palavrasChave || [])}
            placeholder="Selecione..."
            name="react-select-chip-label"
            label="Palavras-chave"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-label',
                loadOptions: API.keywords.getSelectKeywords,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((contentFormErrors.fields || {})['palavrasChave'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['palavrasChave'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <FormControl
          error={!((contentFormErrors.fields || {})['pesoDA'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-pesoDA">Peso DA</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="number"
            onChange={e => {
              handleChangeContent({ ...content, pesoDA: e.target.value })
            }}
            value={content.pesoDA}
            id="field-pesoDA"
          />
          {!((contentFormErrors.fields || {})['pesoDA'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['pesoDA'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['idioma'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-idioma">Idioma</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, idioma: e.target.value })
            }}
            value={content.idioma}
            id="field-idioma"
          />
          {!((contentFormErrors.fields || {})['idioma'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['idioma'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl fullWidth className={classes.formControl}>
          <InputLabel htmlFor="age-simple">Tempo de Leitura</InputLabel>
          <Select
            disabled={isReadOnly}
            error={!((contentFormErrors.fields || {})['minutosLeitura'] || {}).valid && formTouched}
            onChange={e => {
              handleChangeContent({
                ...content,
                minutosLeitura: e.target.value
              })
            }}
            value={content.minutosLeitura || ''}
          >
            {(imagesTime || []).map(imageTime => {
              return (
                <MenuItem key={imageTime._id} value={imageTime.tempo}>
                  {imageTime.nome}
                </MenuItem>
              )
            })}
          </Select>
          {!((contentFormErrors.fields || {})['minutosLeitura'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['minutosLeitura'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl className={classes.formControl} fullWidth>
          <InputLabel htmlFor="content-origin">Tipo origem</InputLabel>
          <Select
            id="content-origin"
            value={content.tipoOrigem}
            disabled={!!content._id}
            onChange={e => {
              handleChangeContent({ ...content, tipoOrigem: e.target.value })
            }}
          >
            <MenuItem key="Artigo" value="artigo">
              Artigo
            </MenuItem>
            <MenuItem key="Capítulo" value="capitulo">
              Capítulo
            </MenuItem>
            <MenuItem key="Diagnóstico e tratamento" value="diagnostico_e_tratamento">
              Diagnóstico e tratamento
            </MenuItem>
          </Select>
        </FormControl>
        {content.tipoOrigem === 'artigo' && (
          <fieldset>
            <legend>Artigo</legend>
            <div className={classes.formControl}>
              <TextField
                disabled={isReadOnly}
                fullWidth
                className={classes.formControl}
                onChange={origemId => {
                  handleChangeReference('artigo', origemId)
                }}
                error={!((contentFormErrors.fields || {})['origemId'] || {}).valid && formTouched}
                value={content.origemId}
                placeholder="Selecione..."
                name="react-select-chip-label"
                label="Pré-cadastro"
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  inputComponent: SelectWrapped,
                  inputProps: {
                    multi: false,
                    filterOptions: filterOptionsFunction,
                    instanceId: 'react-select-chip-label',
                    id: 'react-select-chip-label',
                    options: [],
                    loadOptions: API.content.getSelectContents('artigo')
                  }
                }}
              />
              {!((contentFormErrors.fields || {})['origemId'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['origemId'] || {}).errorMessage}
                </Typography>
              ) : null}
            </div>
            <FormControl
              error={!((contentFormErrors.fields || {})['tituloArtigo'] || {}).valid && formTouched}
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-tituloArtigo">Título do artigo</InputLabel>
              <Input
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                type="text"
                onChange={e => {
                  handleChangeContent({ ...content, tituloArtigo: e.target.value })
                }}
                value={content.tituloArtigo}
                id="field-tituloArtigo"
              />
              {!((contentFormErrors.fields || {})['tituloArtigo'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['tituloArtigo'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
            <FormControl
              error={!((contentFormErrors.fields || {})['codigoArtigo'] || {}).valid && formTouched}
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-codigoArtigo">Código artigo</InputLabel>
              <Input
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                type="text"
                onChange={e => {
                  handleChangeContent({ ...content, codigoArtigo: e.target.value })
                }}
                value={content.codigoArtigo || ''}
                id="field-codigoArtigo"
              />
              {!((contentFormErrors.fields || {})['codigoArtigo'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['codigoArtigo'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
            <FormControl
              error={
                !((contentFormErrors.fields || {})['codigoProtheus'] || {}).valid && formTouched
              }
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-codigoProtheus">Código Protheus</InputLabel>
              <Input
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                type="text"
                inputComponent={IsbnField}
                onChange={e => {
                  handleChangeContent({ ...content, codigoProtheus: e.target.value })
                }}
                value={content.codigoProtheus || ''}
                id="field-codigoProtheus"
              />
              {!((contentFormErrors.fields || {})['codigoProtheus'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['codigoProtheus'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
            <div className={classes.formControl}>
              <TextField
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                onChange={obj => {
                  handleChangeContent({ ...content, autoresArtigo: obj })
                }}
                error={
                  !((contentFormErrors.fields || {})['autoresArtigo'] || {}).valid && formTouched
                }
                value={formatContentSelectValue(content.autoresArtigo || [])}
                placeholder="Selecione..."
                name="react-select-chip-label"
                label="Autores artigo"
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  inputComponent: SelectWrapped,
                  inputProps: {
                    multi: true,
                    filterOptions: filterOptionsFunction,
                    instanceId: 'react-select-chip-label',
                    id: 'react-select-chip-label',
                    loadOptions: API.authors.getSelectAuthors,
                    disableDelete: !!content.origemId || isReadOnly
                  }
                }}
              />
              {!((contentFormErrors.fields || {})['autoresArtigo'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['autoresArtigo'] || {}).errorMessage}
                </Typography>
              ) : null}
            </div>
            <div className={classes.formControl}>
              <TextField
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                onChange={obj => {
                  handleChangeContent({ ...content, editoresArtigo: obj })
                }}
                error={
                  !((contentFormErrors.fields || {})['editoresArtigo'] || {}).valid && formTouched
                }
                value={formatContentSelectValue(content.editoresArtigo || [])}
                placeholder="Selecione..."
                name="react-select-chip-label"
                label="Editores artigo"
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  inputComponent: SelectWrapped,
                  inputProps: {
                    multi: true,
                    filterOptions: filterOptionsFunction,
                    instanceId: 'react-select-chip-label',
                    id: 'react-select-chip-label',
                    loadOptions: API.authors.getSelectAuthors,
                    disableDelete: !!content.origemId || isReadOnly
                  }
                }}
              />
              {!((contentFormErrors.fields || {})['editoresArtigo'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['editoresArtigo'] || {}).errorMessage}
                </Typography>
              ) : null}
            </div>
            <FormControl
              error={
                !((contentFormErrors.fields || {})['anoPublicacaoArtigo'] || {}).valid &&
                formTouched
              }
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-anoPublicacaoArtigo">Ano de publicação</InputLabel>
              <Input
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                inputComponent={CopyrightField || ''}
                onChange={e => {
                  handleChangeContent({ ...content, anoPublicacaoArtigo: e.target.value })
                }}
                value={content.anoPublicacaoArtigo}
                id="field-anoPublicacaoArtigo"
              />
              {!((contentFormErrors.fields || {})['anoPublicacaoArtigo'] || {}).valid &&
              formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['anoPublicacaoArtigo'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
            <FormControl
              error={
                !((contentFormErrors.fields || {})['dataAtualizacao'] || {}).valid && formTouched
              }
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-dataAtualizacao">Data de Atualização</InputLabel>
              <Input
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                type="text"
                inputComponent={DateField}
                onChange={e => {
                  handleChangeContent({ ...content, dataAtualizacao: e.target.value })
                }}
                value={content.dataAtualizacao || ''}
                id="field-dataAtualizacao"
              />
              {!((contentFormErrors.fields || {})['dataAtualizacao'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['dataAtualizacao'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
          </fieldset>
        )}

        {content.tipoOrigem === 'capitulo' && (
          <fieldset>
            <legend>Capítulo</legend>
            <div className={classes.formControl}>
              <TextField
                disabled={isReadOnly}
                fullWidth
                className={classes.formControl}
                onChange={origemId => {
                  handleChangeReference('capitulo', origemId)
                }}
                error={!((contentFormErrors.fields || {})['origemId'] || {}).valid && formTouched}
                value={content.origemId}
                placeholder="Selecione..."
                name="react-select-chip-label"
                label="Pré-cadastro"
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  inputComponent: SelectWrapped,
                  inputProps: {
                    multi: false,
                    filterOptions: filterOptionsFunction,
                    instanceId: 'react-select-chip-label',
                    id: 'react-select-chip-label',
                    options: [],
                    loadOptions: API.content.getSelectContents('capitulo')
                  }
                }}
              />
              {!((contentFormErrors.fields || {})['origemId'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['origemId'] || {}).errorMessage}
                </Typography>
              ) : null}
            </div>
            <FormControl
              error={
                !((contentFormErrors.fields || {})['tituloCapitulo'] || {}).valid && formTouched
              }
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-tituloCapitulo">Título capítulo</InputLabel>
              <Input
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                type="text"
                onChange={e => {
                  handleChangeContent({ ...content, tituloCapitulo: e.target.value })
                }}
                value={content.tituloCapitulo}
                id="field-tituloCapitulo"
              />
              {!((contentFormErrors.fields || {})['tituloCapitulo'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['tituloCapitulo'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
            <FormControl
              error={
                !((contentFormErrors.fields || {})['codigoCapitulo'] || {}).valid && formTouched
              }
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-codigoCapitulo">Código capítulo</InputLabel>
              <Input
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                type="text"
                inputComponent={CodigoCapituloField}
                onChange={e => {
                  handleChangeContent({ ...content, codigoCapitulo: e.target.value })
                }}
                value={content.codigoCapitulo || ''}
                id="field-codigoCapitulo"
              />
              {!((contentFormErrors.fields || {})['codigoCapitulo'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['codigoCapitulo'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
          </fieldset>
        )}

        {content.tipoOrigem === 'capitulo' && (
          <fieldset>
            <legend>Livro</legend>
            <div className={classes.formControl}>
              <TextField
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                className={classes.formControl}
                onChange={livroReferencia => {
                  handleChangeReference('livro', livroReferencia)
                }}
                error={
                  !((contentFormErrors.fields || {})['livroReferencia'] || {}).valid && formTouched
                }
                value={content.livroReferencia}
                placeholder="Selecione..."
                name="react-select-chip-label"
                label="Pré-cadastro"
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  inputComponent: SelectWrapped,
                  inputProps: {
                    multi: false,
                    filterOptions: filterOptionsFunction,
                    instanceId: 'react-select-chip-label',
                    id: 'react-select-chip-label',
                    options: [],
                    loadOptions: API.preRegistrations.getSelectPreRegistrations('livro')
                  }
                }}
              />
              {!((contentFormErrors.fields || {})['livroReferencia'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['livroReferencia'] || {}).errorMessage}
                </Typography>
              ) : null}
            </div>
            <FormControl
              error={!((contentFormErrors.fields || {})['tituloLivro'] || {}).valid && formTouched}
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-tituloLivro">Título livro</InputLabel>
              <Input
                disabled={!!content.livroReferencia || !!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                type="text"
                onChange={e => {
                  handleChangeContent({ ...content, tituloLivro: e.target.value })
                }}
                value={content.tituloLivro}
                id="field-tituloLivro"
              />
              {!((contentFormErrors.fields || {})['tituloLivro'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['tituloLivro'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
            <div className={classes.formControl}>
              <TextField
                disabled={!!content.livroReferencia || !!content.origemId || isReadOnly}
                fullWidth
                onChange={obj => {
                  handleChangeContent({ ...content, autoresLivro: obj })
                }}
                error={
                  !((contentFormErrors.fields || {})['autoresLivro'] || {}).valid && formTouched
                }
                value={formatContentSelectValue(content.autoresLivro || [])}
                placeholder="Selecione..."
                name="react-select-chip-label"
                label="Autores livro"
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  inputComponent: SelectWrapped,
                  inputProps: {
                    multi: true,
                    filterOptions: filterOptionsFunction,
                    instanceId: 'react-select-chip-label',
                    id: 'react-select-chip-label',
                    loadOptions: API.authors.getSelectAuthors,
                    disableDelete: !!content.livroReferencia || !!content.origemId || isReadOnly
                  }
                }}
              />
              {!((contentFormErrors.fields || {})['autoresLivro'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['autoresLivro'] || {}).errorMessage}
                </Typography>
              ) : null}
            </div>
            <FormControl
              error={!((contentFormErrors.fields || {})['isbn'] || {}).valid && formTouched}
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-isbn">ISBN</InputLabel>
              <Input
                disabled={!!content.livroReferencia || !!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                inputComponent={IsbnField}
                type="text"
                onChange={e => {
                  handleChangeContent({ ...content, isbn: e.target.value })
                }}
                value={content.isbn || ''}
                id="field-isbn"
              />
              {!((contentFormErrors.fields || {})['isbn'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['isbn'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
            <FormControl
              error={
                !((contentFormErrors.fields || {})['codigoProtheus'] || {}).valid && formTouched
              }
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-codigoProtheus">Código Protheus</InputLabel>
              <Input
                disabled={!!content.livroReferencia || !!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                type="text"
                inputComponent={IsbnField}
                onChange={e => {
                  handleChangeContent({ ...content, codigoProtheus: e.target.value })
                }}
                value={content.codigoProtheus || ''}
                id="field-codigoProtheus"
              />
              {!((contentFormErrors.fields || {})['codigoProtheus'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['codigoProtheus'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
            <FormControl
              error={
                !((contentFormErrors.fields || {})['copyrightLivro'] || {}).valid && formTouched
              }
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-copyrightLivro">Ano copyright</InputLabel>
              <Input
                disabled={!!content.livroReferencia || !!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                inputComponent={CopyrightField || ''}
                onChange={e => {
                  handleChangeContent({ ...content, copyrightLivro: e.target.value })
                }}
                value={content.copyrightLivro}
                id="field-copyrightLivro"
              />
              {!((contentFormErrors.fields || {})['copyrightLivro'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['copyrightLivro'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
            <FormControl
              error={!((contentFormErrors.fields || {})['edicaoLivro'] || {}).valid && formTouched}
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-edicaoLivro">Edição</InputLabel>
              <Input
                disabled={!!content.livroReferencia || !!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                type="text"
                inputComponent={EdicaoField}
                onChange={e => {
                  handleChangeContent({ ...content, edicaoLivro: e.target.value })
                }}
                value={content.edicaoLivro || ''}
                id="field-edicaoLivro"
              />
              {!((contentFormErrors.fields || {})['edicaoLivro'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['edicaoLivro'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
            <div className={classes.formControl}>
              <TextField
                disabled={!!content.livroReferencia || !!content.origemId || isReadOnly}
                fullWidth
                onChange={obj => {
                  handleChangeContent({ ...content, especialidadesLivro: obj })
                }}
                error={
                  !((contentFormErrors.fields || {})['especialidadesLivro'] || {}).valid &&
                  formTouched
                }
                value={formatContentSelectValue(content.especialidadesLivro || [])}
                placeholder="Selecione..."
                name="react-select-chip-label"
                label="Especialidades livro"
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  inputComponent: SelectWrapped,
                  inputProps: {
                    multi: true,
                    filterOptions: filterOptionsFunction,
                    instanceId: 'react-select-chip-label',
                    id: 'react-select-chip-label',
                    loadOptions: API.specialities.getSelectSpecialities,
                    disableDelete: !!content.livroReferencia || !!content.origemId || isReadOnly
                  }
                }}
              />
              {!((contentFormErrors.fields || {})['especialidadesLivro'] || {}).valid &&
              formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['especialidadesLivro'] || {}).errorMessage}
                </Typography>
              ) : null}
            </div>
          </fieldset>
        )}

        {content.tipoOrigem === 'capitulo' && (
          <fieldset>
            <legend>Seção</legend>
            <FormControl
              error={!((contentFormErrors.fields || {})['tituloSecao'] || {}).valid && formTouched}
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-tituloSecao">Título seção</InputLabel>
              <Input
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                type="text"
                onChange={e => {
                  handleChangeContent({ ...content, tituloSecao: e.target.value })
                }}
                value={content.tituloSecao}
                id="field-tituloSecao"
              />
              {!((contentFormErrors.fields || {})['tituloSecao'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['tituloSecao'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
            <div className={classes.formControl}>
              <TextField
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                onChange={obj => {
                  handleChangeContent({ ...content, autoresSecao: obj })
                }}
                error={
                  !((contentFormErrors.fields || {})['autoresSecao'] || {}).valid && formTouched
                }
                value={formatContentSelectValue(content.autoresSecao || [])}
                placeholder="Selecione..."
                name="react-select-chip-label"
                label="Autores seção"
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  inputComponent: SelectWrapped,
                  inputProps: {
                    multi: true,
                    filterOptions: filterOptionsFunction,
                    instanceId: 'react-select-chip-label',
                    id: 'react-select-chip-label',
                    loadOptions: API.authors.getSelectAuthors,
                    disableDelete: !!content.origemId || isReadOnly
                  }
                }}
              />
              {!((contentFormErrors.fields || {})['autoresSecao'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['autoresSecao'] || {}).errorMessage}
                </Typography>
              ) : null}
            </div>
            <FormControl
              error={!((contentFormErrors.fields || {})['textoSecao'] || {}).valid && formTouched}
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-textoSecao">Sobre a seção</InputLabel>
              <Input
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                multiline
                type="text"
                onChange={e => {
                  handleChangeContent({ ...content, textoSecao: e.target.value })
                }}
                value={content.textoSecao}
                id="field-textoSecao"
              />
              {!((contentFormErrors.fields || {})['textoSecao'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['textoSecao'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
          </fieldset>
        )}

        {content.tipoOrigem === 'diagnostico_e_tratamento' && (
          <fieldset>
            <legend>Diagnóstico e tratamento</legend>
            <div className={classes.formControl}>
              <TextField
                disabled={isReadOnly}
                fullWidth
                className={classes.formControl}
                onChange={origemId => {
                  handleChangeReference('diagnostico_e_tratamento', origemId)
                }}
                error={!((contentFormErrors.fields || {})['origemId'] || {}).valid && formTouched}
                value={content.origemId}
                placeholder="Selecione..."
                name="react-select-chip-label"
                label="Pré-cadastro"
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  inputComponent: SelectWrapped,
                  inputProps: {
                    multi: false,
                    filterOptions: filterOptionsFunction,
                    instanceId: 'react-select-chip-label',
                    id: 'react-select-chip-label',
                    options: [],
                    loadOptions: API.content.getSelectContents('diagnostico_e_tratamento')
                  }
                }}
              />
              {!((contentFormErrors.fields || {})['origemId'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['origemId'] || {}).errorMessage}
                </Typography>
              ) : null}
            </div>
            <FormControl
              error={!((contentFormErrors.fields || {})['tituloDeT'] || {}).valid && formTouched}
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-tituloDeT">Título do d&t</InputLabel>
              <Input
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                type="text"
                onChange={e => {
                  handleChangeContent({ ...content, tituloDeT: e.target.value })
                }}
                value={content.tituloDeT}
                id="field-tituloDeT"
              />
              {!((contentFormErrors.fields || {})['tituloDeT'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['tituloDeT'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
            <FormControl
              error={!((contentFormErrors.fields || {})['codigoDeT'] || {}).valid && formTouched}
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-codigoDeT">Código d&t</InputLabel>
              <Input
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                type="text"
                onChange={e => {
                  handleChangeContent({ ...content, codigoDeT: e.target.value })
                }}
                value={content.codigoDeT || ''}
                id="field-codigoDeT"
              />
              {!((contentFormErrors.fields || {})['codigoDeT'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['codigoDeT'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
            <FormControl
              error={
                !((contentFormErrors.fields || {})['codigoProtheus'] || {}).valid && formTouched
              }
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-codigoProtheus">Código Protheus</InputLabel>
              <Input
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                type="text"
                inputComponent={IsbnField}
                onChange={e => {
                  handleChangeContent({ ...content, codigoProtheus: e.target.value })
                }}
                value={content.codigoProtheus || ''}
                id="field-codigoProtheus"
              />
              {!((contentFormErrors.fields || {})['codigoProtheus'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['codigoProtheus'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
            <div className={classes.formControl}>
              <TextField
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                onChange={obj => {
                  handleChangeContent({ ...content, autoresDeT: obj })
                }}
                error={!((contentFormErrors.fields || {})['autoresDeT'] || {}).valid && formTouched}
                value={formatContentSelectValue(content.autoresDeT || [])}
                placeholder="Selecione..."
                name="react-select-chip-label"
                label="Autores d&t"
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  inputComponent: SelectWrapped,
                  inputProps: {
                    multi: true,
                    filterOptions: filterOptionsFunction,
                    instanceId: 'react-select-chip-label',
                    id: 'react-select-chip-label',
                    loadOptions: API.authors.getSelectAuthors,
                    disableDelete: !!content.origemId || isReadOnly
                  }
                }}
              />
              {!((contentFormErrors.fields || {})['autoresDeT'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['autoresDeT'] || {}).errorMessage}
                </Typography>
              ) : null}
            </div>
            <div className={classes.formControl}>
              <TextField
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                onChange={obj => {
                  handleChangeContent({ ...content, editoresDeT: obj })
                }}
                error={
                  !((contentFormErrors.fields || {})['editoresDeT'] || {}).valid && formTouched
                }
                value={formatContentSelectValue(content.editoresDeT || [])}
                placeholder="Selecione..."
                name="react-select-chip-label"
                label="Editores d&t"
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  inputComponent: SelectWrapped,
                  inputProps: {
                    multi: true,
                    filterOptions: filterOptionsFunction,
                    instanceId: 'react-select-chip-label',
                    id: 'react-select-chip-label',
                    loadOptions: API.authors.getSelectAuthors,
                    disableDelete: !!content.origemId || isReadOnly
                  }
                }}
              />
              {!((contentFormErrors.fields || {})['editoresDeT'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['editoresDeT'] || {}).errorMessage}
                </Typography>
              ) : null}
            </div>
            <FormControl
              error={
                !((contentFormErrors.fields || {})['anoPublicacaoDeT'] || {}).valid && formTouched
              }
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-anoPublicacaoDeT">Ano de publicação</InputLabel>
              <Input
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                inputComponent={CopyrightField || ''}
                onChange={e => {
                  handleChangeContent({ ...content, anoPublicacaoDeT: e.target.value })
                }}
                value={content.anoPublicacaoDeT}
                id="field-anoPublicacaoDeT"
              />
              {!((contentFormErrors.fields || {})['anoPublicacaoDeT'] || {}).valid &&
              formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['anoPublicacaoDeT'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
            <FormControl
              error={
                !((contentFormErrors.fields || {})['dataAtualizacao'] || {}).valid && formTouched
              }
              className={classes.formControl}
              fullWidth
            >
              <InputLabel htmlFor="field-dataAtualizacao">Data de Atualização</InputLabel>
              <Input
                disabled={!!content.origemId || isReadOnly}
                fullWidth
                required={'required'}
                type="text"
                inputComponent={DateField}
                onChange={e => {
                  handleChangeContent({ ...content, dataAtualizacao: e.target.value })
                }}
                value={content.dataAtualizacao || ''}
                id="field-dataAtualizacao"
              />
              {!((contentFormErrors.fields || {})['dataAtualizacao'] || {}).valid && formTouched ? (
                <Typography className={classes.errorMessage} noWrap color={'error'}>
                  {((contentFormErrors.fields || {})['dataAtualizacao'] || {}).errorMessage}
                </Typography>
              ) : null}
            </FormControl>
          </fieldset>
        )}
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    content: state.content.content,
    contentFormErrors: state.content.contentFormErrors,
    imagesTime: state.imagesTime.imagesTime,
    formTouched: state.content.contentFormTouched,
    token: state.auth.token
  }
}
const mapDispatchToProps = dispatch => {
  return {
    handleChangeContent: content => {
      dispatch(contentActions.handleChangeContent(content))
    },
    handleChangeReference: (refType, reference) => {
      dispatch(contentActions.handleChangeReference({ refType, reference }))
    },
    setContentFormTouched: () => {
      return dispatch(contentActions.setContentFormTouched())
    },
    fetchImagesTimeAll: () => {
      dispatch(imagesTimeActions.fetchImagesTimeAll())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(Aula))



// WEBPACK FOOTER //
// ./src/containers/Content/ContentTypes/Tabela.js